<template>
    <div class="mini-swiper-content">
        <el-carousel :interval="4000" :direction="isDesktop ? 'horizontal' : 'vertical'" :type="isDesktop ? 'card' : ''"
            trigger="click" indicator-position="none">
            <el-carousel-item v-for="(item, idx) in swiperUrl" :key="idx">
                <!-- <h3 class="medium">{{ item }}</h3> -->
                <a href="https://www.macauticket.com/TicketWeb2023" target="_blank" class="link"
                    style="height: 100%;width: 100%;">
                    <img class="image" :src="item" alt="" style="width: 100%;  ">
                </a>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>

export default {
    data() {
        return {
            swiperUrl: ['https://macauticket.obs.cn-macau-221.ctmcloud.com.mo/Travel/Banner/CHIMELONG.jpg',
                'https://macauticket.obs.cn-macau-221.ctmcloud.com.mo/Travel/Banner/HAPP_YEAR.jpg',
                'https://macauticket.obs.cn-macau-221.ctmcloud.com.mo/Travel/Banner/ZHANG_YIMOU.jpg',
                'https://macauticket.obs.cn-macau-221.ctmcloud.com.mo/Travel/Banner/DANSING_WATER.jpg'
            ],
            isDesktop: window.innerWidth >= 768,
        };
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            // 更新设备类型，增加防抖（避免窗口频繁resize触发多次更新）

            this.resizeTimer = setTimeout(() => {
                this.isDesktop = window.innerWidth >= 768;
            }, 500);
        },
    },
};
</script>

<style scoped lang="scss">
.mini-swiper-content {
    padding: 3rem;

    // margin: 30px 0;
    .image {
        height: 100%;
    }
}


// 移动端核心优化：停止动画 + 字体适配变小
@media (max-width: 768px) {
    .mini-swiper-content {
        // background-color: rgba(255, 166, 0, 0.842);
         padding: 3rem 0;
    }
}
</style>